if($('.loan-application-container').length) {

    // Pre-fill form with selected vehicle data if available
    let form = $('#gform_3');

    if(form.length && window.selectedVehicle) {
        let price = '';
        if(window.selectedVehicle.price) {
            price = window.selectedVehicle.price.replace(/[^0-9.-]+/g, "");
            price = parseFloat(price);
            price = isFinite(price) ? price : 0;
            price = '$' + price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        }

        let mileage = '';
        if(window.selectedVehicle.mileage) {
            mileage = window.selectedVehicle.mileage.replace(/[^0-9.-]+/g, "");
            mileage = parseInt(mileage);
            mileage = isFinite(mileage) ? mileage : 0;
            mileage = mileage.toLocaleString();
        }

        if(window.selectedVehicle.vin) form.find('input[name="input_1"]').val(window.selectedVehicle.vin);
        if(window.selectedVehicle.year) form.find('input[name="input_3"]').val(window.selectedVehicle.year);
        if(window.selectedVehicle.make) form.find('input[name="input_4"]').val(window.selectedVehicle.make);
        if(window.selectedVehicle.model) form.find('input[name="input_5"]').val(window.selectedVehicle.model);
        if(price) form.find('input[name="input_6"]').val(price);
        if(mileage) form.find('input[name="input_7"]').val(mileage);
    }

    // Handling of the vehicle selection tool
    let changeVehicleBtn = $('#change-vehicle-btn'),
        vehicleListToggle = $('.toggle-vehicle-selection-button'),
        vehicleListContainer = $('.vehicle-list-dropdown'),
        vehicleList = $('#vehicle-selection-modal');

    vehicleListToggle.on('click', function() {
        $(this).toggleClass('active');
        vehicleListContainer.slideToggle();
    });

    changeVehicleBtn.on('click', function() {
        vehicleList.slideDown();
    });

}
